import { lineShape } from './line-shape.js';
import { numberStringInput } from './number-string-input.js';
/** The fields of one credit line as a form holds them: every number is a string, checked by the API's own number schemas. */
export const creditLineFormFields = {
    productTreeId: lineShape.productTreeId,
    quantity: numberStringInput(lineShape.quantity, 'Quantity'),
    unitPrice: numberStringInput(lineShape.unitPrice, 'Unit price'),
    percentageOff: numberStringInput(lineShape.percentageOff, 'Percentage off'),
    customerPaid: numberStringInput(lineShape.customerPaid, 'Customer paid'),
};
//# sourceMappingURL=line-form-fields.js.map